import { EnumUtility } from '@codequality/vue-cli-base';
import _ from 'lodash';
import mixins from 'vue-typed-mixins';

import { E勘定科目カテゴリ, E補助科目フラグ, E製造原価科目未使用フラグ } from '@/openapi/enum';
import { 勘定科目Api, 勘定科目ListItemResponse } from '@/openapi/user';

import Tabs from '@/components/tabs/Tabs.vue';
import C勘定科目TableEditRow from '@/components/勘定科目/table/editRow/勘定科目TableEditRow.vue';
import C勘定科目TableHeader from '@/components/勘定科目/table/header/勘定科目TableHeader.vue';
import ListMixin from '@/entries/user/mixins/ListMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 勘定科目Mixin, { new勘定科目ListItemResponse } from '@/entries/user/mixins/勘定科目Mixin';
import 勘定科目SaveMixin from '@/entries/user/mixins/勘定科目SaveMixin';
import 勘定科目UpdateOrderCheckerMixin from '@/entries/user/mixins/勘定科目UpdateOrderCheckerMixin';
import AlertMixin from '@/mixins/AlertMixin';

import { 補助科目設定不可大分類s } from '@/classes/common/Constants';
import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(
  AlertMixin,
  ListMixin,
  RoutesMixin,
  事業所Mixin,
  勘定科目Mixin,
  勘定科目SaveMixin,
  勘定科目UpdateOrderCheckerMixin
).extend({
  name: 'P勘定科目',

  components: {
    Tabs,
    C勘定科目TableEditRow,
    C勘定科目TableHeader,
  },

  data(): {
    api: 勘定科目Api;
    selectedカテゴリ: E勘定科目カテゴリ;
    selected勘定科目: string;
    勘定科目s: 勘定科目ListItemResponse[];
    new勘定科目: 勘定科目ListItemResponse;
    edit勘定科目: 勘定科目ListItemResponse;
    補助科目s: 勘定科目ListItemResponse[];
    edit補助科目: 勘定科目ListItemResponse;
    visibleDialog: boolean;
  } {
    return {
      api: UserApiUtility.ogApi(勘定科目Api),
      selectedカテゴリ: E勘定科目カテゴリ.損益,
      selected勘定科目: '',
      勘定科目s: [],
      new勘定科目: new勘定科目ListItemResponse(),
      edit勘定科目: new勘定科目ListItemResponse(),
      補助科目s: [],
      edit補助科目: new勘定科目ListItemResponse(false),
      visibleDialog: false,
    };
  },

  computed: {
    disableUpdate補助科目(): boolean {
      return this.edit補助科目.pk === 0;
    },
    tabs(): string[] {
      return EnumUtility.keys(E勘定科目カテゴリ).filter(
        // TODO: 暫定対応
        (k) => k !== '製造原価' || this.事業所.c製造原価科目未使用フラグ === E製造原価科目未使用フラグ.使用する
      );
    },
    カテゴリ勘定科目s(): 勘定科目ListItemResponse[] {
      return this.勘定科目s.filter((勘) => 勘.cカテゴリ === this.selectedカテゴリ);
    },
    is貸借(): boolean {
      return this.is貸借カテゴリ(this.selectedカテゴリ);
    },
  },

  async created(): Promise<void> {
    await this.$_load勘定科目();
  },

  methods: {
    canSet補助科目(勘: 勘定科目ListItemResponse): boolean {
      return !補助科目設定不可大分類s.includes(勘.c大分類);
    },
    changeTab(category: E勘定科目カテゴリ): void {
      this.selectedカテゴリ = category;
      this.clearEdit勘定科目(true);
      this.clearEdit勘定科目(false);
    },
    async update勘定科目並び順(勘: 勘定科目ListItemResponse): Promise<void> {
      await this.api.update勘定科目並び順(勘.pk);
      if (勘.c補助科目フラグ === E補助科目フラグ.通常) this.$_load勘定科目();
      else this.$_load補助科目();
    },
    setEdit勘定科目(勘: 勘定科目ListItemResponse): void {
      this.edit勘定科目 = _.cloneDeep(勘);
    },
    async remove勘定科目(pk: number): Promise<void> {
      if (await this.$_remove勘定科目(pk)) return;
      this.$_load勘定科目();
    },
    async save勘定科目(isNew: boolean, 勘: 勘定科目ListItemResponse): Promise<void> {
      if (await this.$_save勘定科目(isNew, 勘)) return;
      this.$_load勘定科目();
    },
    clearEdit勘定科目(isNew: boolean): void {
      const init = new勘定科目ListItemResponse();
      if (isNew) {
        this.new勘定科目 = init;
      } else {
        this.edit勘定科目 = init;
      }
    },
    async open補助科目(勘: 勘定科目ListItemResponse): Promise<void> {
      this.selected勘定科目 = 勘.c勘定科目;
      this.$_load補助科目();
      this.visibleDialog = true;
    },
    setEdit補助科目(補: 勘定科目ListItemResponse): void {
      this.edit補助科目 = _.cloneDeep(補);
    },
    async remove補助科目(pk: number): Promise<void> {
      if (await this.$_remove勘定科目(pk)) return;
      this.$_load補助科目();
    },
    async save補助科目(isNew: boolean): Promise<void> {
      if (this.edit補助科目.c補助科目 === undefined || this.edit補助科目.c補助科目 === '') {
        alert('補助科目は入力必須項目です。');
        return;
      }
      if (await this.$_save勘定科目(isNew, this.edit補助科目)) return;
      this.$_load補助科目();
    },
    clearEdit補助科目(): void {
      this.edit補助科目 = new勘定科目ListItemResponse(false);
    },
    async $_remove勘定科目(pk: number): Promise<boolean> {
      return await this.isCancelOrValidationErrorResponseToDelete(() => this.api.delete勘定科目(pk));
    },
    async $_save勘定科目(isNew: boolean, edit勘定科目: 勘定科目ListItemResponse): Promise<boolean> {
      if (edit勘定科目.c補助科目フラグ === E補助科目フラグ.補助) edit勘定科目.c勘定科目 = this.selected勘定科目;

      return this.save勘定科目ByMixin(isNew, this.selectedカテゴリ, edit勘定科目);
    },
    async $_load勘定科目(): Promise<void> {
      // 初期化
      this.clearEdit勘定科目(true);
      this.clearEdit勘定科目(false);

      // 勘定科目取得
      const response = await this.api.list勘定科目(this.事業所.pk, E補助科目フラグ.通常);
      this.勘定科目s = response.data;
      this.setPksCannotUpdateOrder(this.勘定科目s);
    },
    async $_load補助科目(): Promise<void> {
      // 初期化
      this.clearEdit補助科目();
      this.補助科目s = [];

      // 補助科目取得
      const options = {
        params: {
          sj: '補助科目',
        },
      };
      const response = await this.api.list勘定科目(
        this.事業所.pk,
        E補助科目フラグ.補助,
        this.selectedカテゴリ,
        this.selected勘定科目,
        options
      );
      this.補助科目s = response.data;
    },
  },
});
